import React from 'react';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid';
import Table, { TableKind } from '@/components/molecules/common/Table';
import styles from './Table.module.scss';

interface Props {
  rows: GridValidRowModel[];
  columns: GridColDef[];
  loading?: boolean;
  sx?: Record<string, React.CSSProperties>;
  table: TableKind;
  autoHeight?: boolean;
  scrollHorizontal?: boolean;
}
const View: React.FC<Props> = ({ rows, columns, loading, sx, table, autoHeight, scrollHorizontal }) => {
  return (
    <div className={styles.container}>
      <Table
        rows={rows}
        columns={columns}
        loading={loading}
        sx={sx}
        table={table}
        autoHeight={autoHeight}
        scrollHorizontal={scrollHorizontal}
      />
    </div>
  );
};

export default View;
